module.exports = __webpack_public_path__ + "media/images/mypage/icon/white/ico_card-faf45e98e19459f648f3480a5ffdf04f.svg";